import useHeaderColumns from './useHeaderColumns';
import { FullTableProps } from 'src/components/Organisms/FullTable';

const useTable = (tableSettings, tableColumns, url,dataKey):[ any[], FullTableProps, any[] ]  => {
    //const tableData = useApi(url,dataKey);
    const tableData = [];
    const headerColumns = useHeaderColumns(tableSettings.tableId, tableColumns);
    return [tableData,tableSettings, headerColumns];
};
export default useTable;